import { render, staticRenderFns } from "./userAvatar.vue?vue&type=template&id=6022dfa6&"
import script from "./userAvatar.vue?vue&type=script&lang=js&"
export * from "./userAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports